export enum NodeTask {
  SPLICE = 'splice',
  UPDATE = 'update',
}
